export default __webpack_public_path__ + "static/media/wild-sound.dc7f4eb1.mp3";